<template>
  <p
    v-if="targetLocked"
    class="px-8 py-3 flex items-center leading-5 text-gray-500 text-sm"
  >
    <slot />
  </p>
  <router-link
    v-else
    :to="to"
    class="hover:bg-gray-200 px-8 py-3 flex items-center leading-5 text-black transition ease-in-out duration-150 text-sm"
    active-class="bg-gray-200 hover:no-underline"
    @click="trackClick"
  >
    <slot />
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import appStore from '@/stores/app.store'
import appService from '@/services/app.service'
import GoogleTagManagerService from '@/services/google-tag-manager.service'

const props = defineProps<{
  to: object | string // string-> path else use object
  sub?: false
  title?: string
}>()

const targetString = computed(() => props.to?.name || props.to)
const targetLocked = computed(
  () =>
    appStore.state.disabledRoutes &&
    appStore.state.disabledRoutes.includes(targetString.value),
)

const trackClick = (option: string) => {
  GoogleTagManagerService.trackEvent('MainMenuNavi', props.to?.name || props.to)
  appService.pushToDataLayer('menu', props.title, 'main', 'header')
}
</script>
